module.exports = __webpack_public_path__ + "static/media/naluri-icon.5fd09290.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/naluri-icon.svg
// module id = 4082
// module chunks = 63